import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';
import axios from 'axios';
import { Loader2, Lock } from 'lucide-react';

const LOGO_URL = "/logo-andeni.png";
const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error('Completați email și parola');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(API + '/admin/auth/login', { email, password }, { withCredentials: true });
      localStorage.setItem('admin_token', response.data.token);
      localStorage.setItem('admin_user', JSON.stringify(response.data));
      toast.success('Autentificare reușită');
      navigate('/admin');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Email sau parolă incorectă');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center px-6">
      <Card className="w-full max-w-md bg-white">
        <CardHeader className="text-center pb-2">
          <img src={LOGO_URL} alt="AnDeni Time Solutions" className="h-16 w-auto mx-auto mb-4" />
          <CardTitle className="text-xl font-semibold text-slate-900">Admin Panel</CardTitle>
          <p className="text-sm text-slate-500">Autentificați-vă pentru a accesa panoul de administrare</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4" autoComplete="off">
            <div>
              <Label htmlFor="email" className="text-slate-700">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Adresa de email"
                className="mt-1"
                autoComplete="off"
                data-testid="admin-email-input"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-slate-700">Parolă</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Parola de acces"
                className="mt-1"
                autoComplete="off"
                data-testid="admin-password-input"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white"
              data-testid="admin-login-btn"
            >
              {loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Lock className="h-4 w-4 mr-2" />}
              {loading ? 'Se autentifică...' : 'Autentificare'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
